export default "__VITE_ASSET__BxhoY7cy__"